/**
 * Co-Producer / Touring Partner / Project Partner form
 */

import $ from 'jquery';
import _ from 'lodash';
import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import vueSelect from 'vue-select';
import refreshToken from '../mixins/refresh-token';

const dictionary = { en: { messages: { required: 'This field is mandatory' } } };

VeeValidate.Validator.localize(dictionary);

Vue.use(VeeValidate);

Validator.extend('no_160_space', {
    getMessage: field => 'The ' + field + ' field must be a valid email address.',
    validate: function (value) {
        if (value.includes(' ')) {
            return false;
        }

        return true;
    }
});

Validator.extend('url', {
    getMessage: field => 'The ' + field + '\'s address must be in the form http://www.website.com.',
    validate: (value) => value ? /^(ftp|http|https):\/\/[^ "]+$/.test(value) : true
});

// Validator.extend('phone_number', {
//     getMessage: field => 'The ' + field + ' must be a valid phone number.',
//     validate: value => value[0] ? /^0[]$/.test(value[0].name) : true
// });

const formLeadcompanyComponentConfig = {
    /**
     * Component name
     * @type {String}
     */
    name: 'form-leadcompany',

    props: [
        'countries',
        'projectLeadcompanyData',
        'token',
        'previous',
        'action',
        'id',
        'categorie',
        'next',
        'readOnly',
        'errorBags',
        'members',
        'organizations'
    ],

    components: { 'vueSelect': vueSelect },

    mixins: [ refreshToken ],

    /**
     * Component data
     * @return {Object}
     */
    data () {
        const dataObject = {
            projectLeadcompany: {},
            tokenVal: null
        };

        return dataObject;
    },

    methods: {
        validateForm (e) {
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    let phoneNumberText = $('.phone-number-text');
                    let phoneNumberFull = $('.phone-number-full');
                    let phoneNumber = phoneNumberText.intlTelInput('getNumber');

                    let mobileNumberText = $('.mobile-number-text');
                    let mobileNumberFull = $('.mobile-number-full');
                    let mobileNumber = mobileNumberText.intlTelInput('getNumber');

                    // console.log('phone', phoneNumberText.intlTelInput('isValidNumber'));
                    // console.log('mobile', mobileNumberText.intlTelInput('isValidNumber'));

                    let btnSpinner = $('.btn--spinner', e.target);

                    btnSpinner.addClass('right-spin');

                    if (phoneNumberText.intlTelInput('isValidNumber') && mobileNumberText.val() && mobileNumberText.intlTelInput('isValidNumber')) {
                        phoneNumberFull.val(phoneNumber);
                        mobileNumberFull.val(mobileNumber);
                        e.target.submit();

                        return true;
                    }
                    if (phoneNumberText.intlTelInput('isValidNumber') && !mobileNumberText.val()) {
                        phoneNumberFull.val(phoneNumber);
                        e.target.submit();

                        return true;
                    }
                    if (!mobileNumberText.intlTelInput('isValidNumber') && mobileNumberText.val()) {
                        const field = this.$validator.fields.find({
                            name: $('.mobile-number-text').attr('name'),
                            scope: this.$options.scope
                        });

                        this.$validator.errors.add({
                            id: field.name,
                            field: field.name,
                            msg: 'Invalid phone number',
                            scope: this.$options.scope
                        });

                        field.setFlags({
                            invalid: true,
                            valid: false,
                            validated: true
                        });

                        $([document.documentElement, document.body]).animate({
                            scrollTop: $('.mobile-number-text').parents()
                                .eq(2)
                                .offset().top - 130
                        }, 500);
                    }
                    if (!phoneNumberText.intlTelInput('isValidNumber')  && phoneNumberText.val()) {
                        const field = this.$validator.fields.find({
                            name: $('.phone-number-text').attr('name'),
                            scope: this.$options.scope
                        });

                        this.$validator.errors.add({
                            id: field.name,
                            field: field.name,
                            msg: 'Invalid phone number',
                            scope: this.$options.scope
                        });

                        field.setFlags({
                            invalid: true,
                            valid: false,
                            validated: true
                        });

                        $([document.documentElement, document.body]).animate({
                            scrollTop: $('.phone-number-text').parents()
                                .eq(2)
                                .offset().top - 130
                        }, 500);
                    }
                } else {
                    let fieldName = this.errors.items[0].field;

                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('[name="' + fieldName + '"]').parent()
                            .offset().top - 130
                    }, 500);
                }
            });
        },
        validatePhone (e) {
            const field = this.$validator.fields.find({
                name: $(e.target).attr('name'),
                scope: this.$options.scope
            });

            if (!field) return;

            if (!$(e.target).intlTelInput('isValidNumber') && $(e.target).val()) {
                this.$validator.errors.add({
                    id: field.name,
                    field: field.name,
                    msg: 'Invalid phone number',
                    scope: this.$options.scope
                });

                field.setFlags({
                    invalid: true,
                    valid: false,
                    validated: true
                });
            } else {
                this.$validator.errors.removeById(field.name);
            }

            return true;
        },
        readUrl (e) {
            if ($(e.target)[0].files && $(e.target)[0].files[0]) {
                let reader = new FileReader();

                reader.onload = function (event) {
                    $('#' + $(e.target).data('img-id')).attr('src', event.target.result);
                };

                reader.readAsDataURL($(e.target)[0].files[0]);
            }
        }
    },

    /**
     * Created event handler
     * @return {Void}
     */
    created () {
        this.projectLeadcompany = this.projectLeadcompanyData;
        this.tokenVal = this.token;
    },

    mounted () {
        _.each(this.errorBags, (value, fieldname) => {
            const field = this.$validator.fields.find({
                name: fieldname,
                scope: this.$options.scope
            });

            this.$validator.errors.add({
                id: field.name,
                field: field.name,
                msg: value[0],
                scope: this.$options.scope
            });

            field.setFlags({
                invalid: true,
                valid: false,
                validated: true
            });
        });

        if (this.errors.items[0] !== undefined) {
            let fieldName = this.errors.items[0].field;

            $([document.documentElement, document.body]).animate({
                scrollTop: $('[name="' + fieldName + '"]').parent()
                    .offset().top - 130
            }, 500);
        }
    },

    updated () {
        const checkedFields = [
            {
                fieldName: 'member_id',
                relatedData: this.projectLeadcompany.selected_member
            },
            {
                fieldName: 'lead_company_organization',
                relatedData: this.projectLeadcompany.selected_organization
            },
            {
                fieldName: 'lead_company_address_country_id',
                relatedData: this.projectLeadcompany.lead_company_address_country
            }
        ];

        _.each(checkedFields, (element) => {
            if (element.relatedData) {
                const field = this.$validator.fields.find({
                    name: element.fieldName,
                    scope: this.$options.scope
                });

                if (field) {
                    this.$validator.errors.removeById(field.id);
                }
            }
        });
    }
};

const formLeadcompanyComponent = Vue.extend(formLeadcompanyComponentConfig);

export default formLeadcompanyComponent;
